// src/pages/EventDetails.js

import React from 'react';
import './EventDetails.css'; 
import { Link } from 'react-router-dom';  
const weddingWeekendEvents = [

  {
    title: 'Welcome Drinks',
    date: 'Friday, May 16, 2025',
    time: '7:30 PM',
    location: 'The Story Venue',
    address: '450 W Franklin St, Chapel Hill, NC 27516',
    description: 'Join us for a drink and a mingle, a "dringle", if you will, to kick off the wedding festivities!',
    photo: './images/icons/champagne.webp'
  },
  {
    title: 'Wedding Ceremony',
    date: 'Saturday, May 17, 2025',
    time: '4:00 PM',
    location: 'Love\'s Way',
    address: '4519 Murphy School Road, Durham, NC 27705',
    description: 'Our wedding ceremony will take place at the home of our dear friend. All wedding day events will take place at this venue. There will be a short cocktail hour after the ceremony.',
    photo: './images/icons/just-married.webp'
  },
  {
    title: 'Reception',
    date: 'Saturday, May 17, 2025',
    time: '6:00 PM',
    location: 'Ye Grand Backyard Tent',
    address: ' 4519 Murphy School Road, Durham, NC 27705',
    description: 'Celebrate with us at our wedding reception with dinner and dancing!',
    photo: './images/icons/disco-ball.webp',
  },
  // Add more events as needed
];

function EventDetails() {
  return (
    <div className="event-details">
      <div className="background">
      <h1>Schedule of Events</h1>
      {weddingWeekendEvents.map((event, index) => (

        <div key={index} className="event-card">
          <h2>{event.title}</h2>
          <img src={event.photo} alt={event.title} />
          <p>{event.date} at {event.time}</p>
          <p>{event.location}</p>
          <p>{event.address}</p>  
          <p>{event.description}</p>
        </div>
      ))}
      <h1>Dress Code</h1>
      <div className="dress-code">
  
          <h3>Semi-Formal Garden Party Attire</h3>
           <p>We invite you to embrace the beauty of spring and the charm of a garden soirée. Our wedding attire is semi-formal with a soft, romantic garden feel. Think flowing fabrics, dreamy pastels, earthy neutrals, and nature-inspired details. Midi or maxi dresses, light or muted-tone suits, and airy fabrics like chiffon or linen fit the vibe beautifully. We want you to feel comfortable and elegant while embracing the magic of the day with us!
           </p>
           <p>For guidance:</p>
           <p><b>Ladies:</b> Flowing dresses, midi or maxi skirts, jumpsuits, or dressy separates in light, breathable fabrics. Soft pastels, florals, and earthy tones will complement the setting beautifully! Consider wedges, block heels, sandals or flats for comfort on the grass.</p>
           <p><b>Gentlemen:</b> Light suits, dress shirts with slacks, or a tailored blazer with dress pants. Feel free to embrace spring hues, sublte patterns, and breathable fabrics like linen or cotton. Ties are welcome but optional - polished yet relaxed is the goal!</p>
           <p><b>Extras:</b> We encourage hats, fascinators, and playful accessories for that garden party touch! The ceremony and reception will be outdoors, so plan accordingly for sunshine and soft terrain.</p>
           <p>For more inspiration, please view our pinterest page, linked below!</p>
           <Link to="https://www.pinterest.com/booglyboo/wedding-guest-attire/" target="_blank" rel="noopener noreferrer">Wedding Guest Attire Inspiration</Link>
           <p>If you have any questions, feel free to reach out!</p>
        
      </div>

          {/* PARKING DETAILS */}
    <div className="parking-details">
      <h2>Event Parking & Directions</h2>
      <p>If you are driving in from the east, Google Maps usually makes a mistake and brings you to a road called Etta road, which is a street just before the entrance to Love's Way. When you are prompted to turn onto Etta road, please ignore the directions and continue on Murphy School Road until you see signs for the wedding.</p>
      <p>Please drive down the long gravel road until you find space to park. If you know you will need assistance parking, please let us know in advance so we can make sure you're taken care of.</p>
    </div>
    </div>
  </div>
  );
}

export default EventDetails;